module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Error")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.error
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.warning
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.success
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.information
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a15e9ac","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationInline.vue
// module id = s9uX
// module chunks = 0